function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled from "@emotion/styled/base";

function cov_2671cx13vl() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx";
  var hash = "e59d378df5027bc0284258ce62604473c876a265";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 23
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 49,
          column: 48
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "2": {
        start: {
          line: 54,
          column: 34
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "3": {
        start: {
          line: 60,
          column: 48
        },
        end: {
          line: 60,
          column: 58
        }
      },
      "4": {
        start: {
          line: 61,
          column: 29
        },
        end: {
          line: 61,
          column: 39
        }
      },
      "5": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 91,
          column: 6
        }
      },
      "6": {
        start: {
          line: 73,
          column: 14
        },
        end: {
          line: 85,
          column: 31
        }
      },
      "7": {
        start: {
          line: 95,
          column: 36
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "8": {
        start: {
          line: 96,
          column: 27
        },
        end: {
          line: 96,
          column: 37
        }
      },
      "9": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 102,
          column: 9
        }
      },
      "10": {
        start: {
          line: 105,
          column: 34
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "11": {
        start: {
          line: 106,
          column: 27
        },
        end: {
          line: 106,
          column: 37
        }
      },
      "12": {
        start: {
          line: 108,
          column: 25
        },
        end: {
          line: 108,
          column: 94
        }
      },
      "13": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 61
        }
      },
      "14": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 115,
          column: 9
        }
      },
      "15": {
        start: {
          line: 118,
          column: 34
        },
        end: {
          line: 130,
          column: 3
        }
      },
      "16": {
        start: {
          line: 119,
          column: 37
        },
        end: {
          line: 119,
          column: 47
        }
      },
      "17": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 61
        }
      },
      "18": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "19": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 18
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 59
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 72,
            column: 20
          },
          end: {
            line: 72,
            column: 21
          }
        },
        loc: {
          start: {
            line: 73,
            column: 14
          },
          end: {
            line: 85,
            column: 31
          }
        },
        line: 73
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 95,
            column: 36
          },
          end: {
            line: 95,
            column: 37
          }
        },
        loc: {
          start: {
            line: 95,
            column: 50
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 95
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 105,
            column: 34
          },
          end: {
            line: 105,
            column: 35
          }
        },
        loc: {
          start: {
            line: 105,
            column: 48
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 105
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 118,
            column: 34
          },
          end: {
            line: 118,
            column: 35
          }
        },
        loc: {
          start: {
            line: 118,
            column: 48
          },
          end: {
            line: 130,
            column: 3
          }
        },
        line: 118
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 89,
            column: 9
          },
          end: {
            line: 89,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 9
          },
          end: {
            line: 89,
            column: 33
          }
        }, {
          start: {
            line: 89,
            column: 37
          },
          end: {
            line: 89,
            column: 96
          }
        }],
        line: 89
      },
      "1": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 14
          }
        }, {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 102,
            column: 8
          }
        }],
        line: 98
      },
      "2": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 115,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 14
          }
        }, {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 115,
            column: 8
          }
        }],
        line: 111
      },
      "3": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 127,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 123,
            column: 14
          }
        }, {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 127,
            column: 8
          }
        }],
        line: 123
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e59d378df5027bc0284258ce62604473c876a265"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2671cx13vl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2671cx13vl();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { GoogleLogin } from 'react-google-login';
import { css as cn, cx } from '@emotion/css';
import { colors, radii, fontSizesNamed, fontWeights, fonts } from '@opendoor/bricks/theme/eero';
import { Image, Box, Flex } from '@opendoor/bricks/core';
import { ErrorPrompt } from '@opendoor/bricks/complex';
var ODGoogleButton = (cov_2671cx13vl().s[0]++, _styled("button", process.env.NODE_ENV === "production" ? {
  target: "exig9nf0"
} : {
  target: "exig9nf0",
  label: "ODGoogleButton"
})("background-color:", colors.neutrals0, ";border-radius:", radii.roundedSquare, ";border:2px solid ", colors.neutrals100, ";color:", colors.neutrals100, ";font-weight:", fontWeights.semibold, ";font-family:", fonts.sans, ";font-size:", fontSizesNamed.s0, ";cursor:pointer;height:50px;width:100%;.button-text{font-size:", fontSizesNamed.s1, ";font-weight:", fontWeights.bold, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
export var GoogleAuth = /*#__PURE__*/function (_React$Component) {
  _inherits(GoogleAuth, _React$Component);

  var _super = _createSuper(GoogleAuth);

  function GoogleAuth() {
    var _this;

    _classCallCheck(this, GoogleAuth);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", (cov_2671cx13vl().s[2]++, {
      errorResponse: null,
      errorMessage: ''
    }));

    _defineProperty(_assertThisInitialized(_this), "googleScriptLoadFailure", (cov_2671cx13vl().s[7]++, function (response) {
      cov_2671cx13vl().f[2]++;

      var _ref = (cov_2671cx13vl().s[8]++, _this.props),
          trackEvent = _ref.trackEvent;

      cov_2671cx13vl().s[9]++;
      (cov_2671cx13vl().b[1][0]++, trackEvent) && (cov_2671cx13vl().b[1][1]++, trackEvent('google-auth', 'failed', {
        details: response.details,
        error_code: response.error
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "googleResponseFailure", (cov_2671cx13vl().s[10]++, function (response) {
      cov_2671cx13vl().f[3]++;

      var _ref2 = (cov_2671cx13vl().s[11]++, _this.props),
          trackEvent = _ref2.trackEvent;

      var errorMessage = (cov_2671cx13vl().s[12]++, 'Sorry, the attempt to sign in with Google failed. Please try again.');
      cov_2671cx13vl().s[13]++;

      _this.setState({
        errorResponse: response,
        errorMessage: errorMessage
      });

      cov_2671cx13vl().s[14]++;
      (cov_2671cx13vl().b[2][0]++, trackEvent) && (cov_2671cx13vl().b[2][1]++, trackEvent('google-auth', 'failed', {
        details: response.details,
        error_code: response.error
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "googleResponseSuccess", (cov_2671cx13vl().s[15]++, function (response) {
      cov_2671cx13vl().f[4]++;

      var _ref3 = (cov_2671cx13vl().s[16]++, _this.props),
          onAuthed = _ref3.onAuthed,
          trackEvent = _ref3.trackEvent;

      cov_2671cx13vl().s[17]++;

      _this.setState({
        errorResponse: null,
        errorMessage: ''
      });

      cov_2671cx13vl().s[18]++;
      (cov_2671cx13vl().b[3][0]++, trackEvent) && (cov_2671cx13vl().b[3][1]++, trackEvent('google-auth', 'authed', {
        email: response.profileObj.email,
        name: response.profileObj.name
      }));
      cov_2671cx13vl().s[19]++;
      return onAuthed(response);
    }));

    return _this;
  }

  _createClass(GoogleAuth, [{
    key: "render",
    value: function render() {
      cov_2671cx13vl().f[0]++;

      var _ref4 = (cov_2671cx13vl().s[3]++, this.props),
          className = _ref4.className,
          buttonText = _ref4.buttonText,
          clientId = _ref4.clientId;

      var _ref5 = (cov_2671cx13vl().s[4]++, this.state),
          errorMessage = _ref5.errorMessage;

      cov_2671cx13vl().s[5]++;
      return /*#__PURE__*/React.createElement(Box, {
        width: "100%"
      }, /*#__PURE__*/React.createElement(Flex, {
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(GoogleLogin, {
        className: className,
        clientId: clientId,
        onSuccess: this.googleResponseSuccess,
        onFailure: this.googleResponseFailure,
        onScriptLoadFailure: this.googleScriptLoadFailure,
        render: function render(renderProps) {
          cov_2671cx13vl().f[1]++;
          cov_2671cx13vl().s[6]++;
          return /*#__PURE__*/React.createElement(ODGoogleButton, {
            onClick: renderProps.onClick
          }, /*#__PURE__*/React.createElement(Flex, {
            justifyContent: "center",
            alignItems: "center"
          }, /*#__PURE__*/React.createElement(Image, {
            height: "16px",
            pr: 3,
            src: "https://imgdrop.imgix.net/15c9f888b5c14a489e537a039f2f8883.png",
            alt: "Google logo"
          }), /*#__PURE__*/React.createElement(Box, {
            as: "span",
            fontWeight: "semibold",
            className: "button-text",
            lineHeight: 1
          }, buttonText)));
        }
      })), (cov_2671cx13vl().b[0][0]++, this.state.errorResponse) && (cov_2671cx13vl().b[0][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
        paddingBottom: "16px",
        message: errorMessage
      })));
    } // Called, e.g., when user is in incognito mode or has otherwise blocked third-party cookies

  }]);

  return GoogleAuth;
}((React.Component));

_defineProperty(GoogleAuth, "defaultProps", (cov_2671cx13vl().s[1]++, {
  buttonText: 'Continue with Google',
  className: cx( /*#__PURE__*/cn(ODGoogleButton, process.env.NODE_ENV === "production" ? "" : ";label:defaultProps;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
}));